import React, { Fragment, useState } from 'react';
import MaskedText from "./MaskedText";

const AwbNumber = props => {
  const [state, setState] = useState({
    prefix: props.prefix ? props.prefix : "",
    serial: props.serial ? props.serial : "",
    defaultPrefix: props.defaultPrefix,
    defaultSerial: props.defaultSerial,
    inputProps: props.inputProps,
    mask: props.mask||"999-99999999",
    render: props.render
  });
  if (props.prefix !== state.prefix || props.serial !== state.serial)
    setState({...state, prefix: props.prefix, serial: props.serial})

  /*
  This can be used to customise the mask behaviour

  const beforeMaskedValueChange = (newState, oldState, userInput, maskOptions) => {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPosition = selection ? selection.start : null;

    let newValue = value.trim();
    let oldValue = oldState.value.trim();
    if (newValue.length === 3 &&  cursorPosition === newValue.length && oldValue.length < newValue.length) {
      value = newValue + "-";
      cursorPosition ++;
      selection = { start: cursorPosition, end: cursorPosition };
    }
    if (newValue.length === 4 &&  cursorPosition === newValue.length && newValue.length < oldValue.length) {
      value = newValue.slice(0, 3);
      cursorPosition--;
      selection = { start: cursorPosition, end: cursorPosition };
    }

    const emptyValue = " ".repeat(maskOptions.mask.length);
    value = value + emptyValue.substr(0, emptyValue.length - value.length);
    return {
      value,
      selection
    };
  };


   */

  const handleChange = newValue => {
    // console.log(newValue);
    const separatorPos = newValue.indexOf('-');
    const prefix = newValue.substr(0, separatorPos < 0 ? newValue.length : separatorPos);
    const serial = separatorPos < 0 ? "" : newValue.substr(separatorPos + 1, newValue.length - separatorPos);
    // console.log(number);
    setState({...state, prefix: prefix, serial: serial});
    props.onChange({prefix, serial});
  };

  const formatChars={
    "U": "[A-Z]",
    "X": "[A-Za-z]",
    "A": "[A-Z0-9]",
    "a": "[A-Za-z0-9]",
    "i": "[A-Za-z0-9]-",
    "9": "[0-9]",
    "D": "[0-9.]",
    "x": "."
  }

  if (state.render) {
    return(<span>{`${state.prefix}-${state.serial ? state.serial.toString().padStart(8,"0") : ""}`}</span>)
  }
  return (
    <Fragment>
      <MaskedText
        id={props.id}
        mask={state.mask}
        maskChar={""}
        alwaysShowMask={true}
        //beforeMaskedValueChange={beforeMaskedValueChange}
        formatChars={formatChars}
        permanents={[3]}
        forceUpperCase={true}
        value={state.prefix +"-"+ state.serial}
        variant={props.variant || 'standard'}
        label={props.label || ""}
        required={props.required || false}
        onChange={handleChange}
        inputProps={state.inputProps}
        readOnly={props.readOnly}
      />
    </Fragment>
  )
};

export default AwbNumber;
